
import OptimizedImage from '../../../components/base/OptimizedImage';
import { useState } from 'react';
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const [activeService, setActiveService] = useState(0);

  const services = [
    {
      icon: 'ri-home-4-line',
      title: '套房搬家',
      subtitle: '小資族首選',
      price: '2,500',
      description: '專業新北套房搬家服務，提供台北搬家、桃園搬家家具拆裝、物品包裝、安全運輸等完整搬家服務。',
      features: ['家具拆裝', '物品包裝', '安全運輸', '定位擺放'],
      image: 'https://public.readdy.ai/ai/img_res/5cd316879d6170d0cd9ec43482603cc7.jpg',
      color: 'teal',
      popular: true
    },
    {
      icon: 'ri-building-line',
      title: '辦公室搬遷',
      subtitle: '企業專屬',
      price: '依坪數',
      description: '新北辦公室搬家專家，提供台北、桃園、新竹辦公室搬遷服務，將營運中斷時間降到最低。',
      features: ['辦公設備搬運', '文件整理', 'OA拆裝', '物品定位'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20office%20relocation%20service%20in%20modern%20Taiwan%20office%20building%2C%20skilled%20movers%20carefully%20handling%20desktop%20computers%20monitors%20and%20office%20furniture%2C%20organized%20business%20moving%20with%20cardboard%20boxes%20and%20protective%20materials%2C%20bright%20clean%20corporate%20workspace%20with%20glass%20partitions%20and%20modern%20desks%2C%20efficient%20professional%20moving%20team%20in%20uniform%2C%20natural%20daylight%20through%20large%20windows&width=600&height=400&seq=office-relocation-updated&orientation=landscape',
      color: 'emerald',
      popular: false
    },
    {
      icon: 'ri-delete-bin-line',
      title: '廢棄物清運',
      subtitle: '環保處理',
      price: '500起',
      description: '新北搬家廢棄物清運服務，協助台北、桃園客戶清理家中不需要的物品與垃圾，環保合法處理。',
      features: ['環保回收', '廢棄物分類', '清潔服務', '合法處理'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20waste%20disposal%20and%20recycling%20service%2C%20organized%20sorting%20of%20household%20items%2C%20eco-friendly%20waste%20management%2C%20clean%20disposal%20truck%2C%20environmental%20responsibility%2C%20professional%20waste%20handling%20team%2C%20sustainable%20recycling%20process&width=600&height=400&seq=waste-disposal&orientation=landscape',
      color: 'teal',
      popular: false
    },
    {
      icon: 'ri-team-line',
      title: '人力搬工',
      subtitle: '彈性服務',
      price: '時薪計',
      description: '專業新北搬家人力搬工團隊，提供台北搬家、桃園搬家重物搬運、家具組裝等體力工作。',
      features: ['重物搬運', '家具組裝', '專業工具', '保險保障'],
      image: 'https://readdy.ai/api/search-image?query=Professional%20moving%20crew%20carrying%20heavy%20furniture%2C%20strong%20workers%20in%20safety%20gear%2C%20teamwork%20lifting%20large%20items%2C%20professional%20moving%20equipment%2C%20safety-focused%20moving%20service%2C%20organized%20moving%20team%2C%20reliable%20manual%20labor%20service&width=600&height=400&seq=manual-labor&orientation=landscape',
      color: 'emerald',
      popular: false
    }
  ];

  return (
    <section id="services" className="py-16 md:py-24 bg-gradient-to-br from-gray-50 via-white to-teal-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 標題區域 */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center gap-2 bg-teal-100 text-teal-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <i className="ri-service-line text-lg"></i>
            <span>專業服務項目</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            全方位<span className="text-teal-600">搬家服務</span>
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            從小型套房到大型辦公室，<strong>建鈞搬家</strong>為您量身打造最適合的搬家方案
          </p>
        </div>

        {/* 服務選擇器 - 手機版 */}
        <div className="lg:hidden mb-8">
          <div className="flex overflow-x-auto gap-3 pb-4 scrollbar-hide">
            {services.map((service, index) => (
              <button
                key={index}
                onClick={() => setActiveService(index)}
                className={`flex-shrink-0 px-5 py-3 rounded-full font-semibold transition-all whitespace-nowrap ${
                  activeService === index
                    ? 'bg-teal-600 text-white shadow-lg'
                    : 'bg-white text-gray-700 border border-gray-200'
                }`}
              >
                <i className={`${service.icon} mr-2`}></i>
                {service.title}
              </button>
            ))}
          </div>
        </div>

        {/* 服務卡片網格 */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className={`group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 overflow-hidden border border-gray-100 ${
                activeService === index ? 'lg:ring-2 lg:ring-teal-500' : ''
              }`}
              onMouseEnter={() => setActiveService(index)}
            >
              {/* 圖片區域 */}
              <div className="relative h-56 md:h-64 overflow-hidden">
                <OptimizedImage 
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full group-hover:scale-110 transition-transform duration-700"
                  priority={index < 2}
                />
                
                {/* 漸層遮罩 */}
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
                
                {/* 圖標 */}
                <div className={`absolute top-4 left-4 w-14 h-14 rounded-2xl flex items-center justify-center shadow-lg ${
                  service.color === 'teal' 
                    ? 'bg-gradient-to-br from-teal-500 to-teal-600' 
                    : 'bg-gradient-to-br from-emerald-500 to-emerald-600'
                }`}>
                  <i className={`${service.icon} text-white text-2xl`}></i>
                </div>

                {/* 熱門標籤 */}
                {service.popular && (
                  <div className="absolute top-4 right-4 bg-gradient-to-r from-amber-500 to-orange-500 text-white px-4 py-1.5 rounded-full text-sm font-bold shadow-lg flex items-center gap-1">
                    <i className="ri-fire-line"></i>
                    熱門首選
                  </div>
                )}

                {/* 價格標籤 */}
                <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-xl shadow-lg">
                  <div className="flex items-baseline gap-1">
                    <span className="text-xs text-gray-500">NT$</span>
                    <span className={`text-2xl font-bold ${
                      service.color === 'teal' ? 'text-teal-600' : 'text-emerald-600'
                    }`}>{service.price}</span>
                    <span className="text-xs text-gray-500">起</span>
                  </div>
                </div>

                {/* 副標題 */}
                <div className="absolute bottom-4 right-4 bg-black/50 backdrop-blur-sm text-white px-3 py-1.5 rounded-full text-sm font-medium">
                  {service.subtitle}
                </div>
              </div>
              
              {/* 內容區域 */}
              <div className="p-6 md:p-8">
                <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-5 leading-relaxed text-sm md:text-base">
                  {service.description}
                </p>
                
                {/* 特色標籤 */}
                <div className="flex flex-wrap gap-2 mb-6">
                  {service.features.map((feature, featureIndex) => (
                    <div 
                      key={featureIndex} 
                      className={`flex items-center text-sm px-3 py-1.5 rounded-full ${
                        service.color === 'teal' 
                          ? 'bg-teal-50 text-teal-700' 
                          : 'bg-emerald-50 text-emerald-700'
                      }`}
                    >
                      <i className="ri-check-line mr-1"></i>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                {/* CTA 按鈕 */}
                <div className="flex gap-3">
                  <a 
                    href="https://line.me/ti/p/@285yavdh"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`flex-1 py-3 rounded-xl font-semibold text-center transition-all flex items-center justify-center gap-2 ${
                      service.color === 'teal'
                        ? 'bg-teal-600 text-white hover:bg-teal-700'
                        : 'bg-emerald-600 text-white hover:bg-emerald-700'
                    }`}
                  >
                    <img 
                      src="https://static.readdy.ai/image/9ef47c451bf9aafd7a63eea67af7d95d/c33a3c3f2fa31df7dfad05bfabc09369.webp" 
                      alt="LINE" 
                      className="w-5 h-5"
                    />
                    立即諮詢
                  </a>
                  <Link 
                    to="/services"
                    className="px-5 py-3 rounded-xl font-semibold border-2 border-gray-200 text-gray-700 hover:border-teal-500 hover:text-teal-600 transition-all flex items-center gap-1"
                  >
                    了解更多
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* 底部服務保證 */}
        <div className="mt-12 md:mt-16 bg-gradient-to-r from-teal-600 to-emerald-600 rounded-3xl p-6 md:p-10 shadow-xl">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center text-white">
            <div className="group">
              <div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-shield-check-line text-2xl"></i>
              </div>
              <div className="font-bold text-lg">全程保險</div>
              <div className="text-teal-100 text-sm">物品安全有保障</div>
            </div>
            <div className="group">
              <div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-price-tag-3-line text-2xl"></i>
              </div>
              <div className="font-bold text-lg">透明報價</div>
              <div className="text-teal-100 text-sm">絕無隱藏費用</div>
            </div>
            <div className="group">
              <div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-time-line text-2xl"></i>
              </div>
              <div className="font-bold text-lg">準時服務</div>
              <div className="text-teal-100 text-sm">絕不讓您久等</div>
            </div>
            <div className="group">
              <div className="w-14 h-14 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-3 group-hover:scale-110 transition-transform">
                <i className="ri-customer-service-2-line text-2xl"></i>
              </div>
              <div className="font-bold text-lg">24小時服務</div>
              <div className="text-teal-100 text-sm">隨時為您服務</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
